<template>
  <base-layout toolbarActive :routerBack="false">
    <template #toolbarBase>
      <router-link :to="{ name: 'theme' }" class="link">
        <span v-if="!isMobile" class="valign-middle font-weight-medium">
          <icon-arrow size="17" class="mx-3"></icon-arrow>
          К списку всех тем
        </span>
        <span
          class=" text--secondary adv-date layout align-center pb-0"
          v-if="isMobile && item.id"
        >
          <icon-arrow size="17" class="mx-3"></icon-arrow>
          <div class="font-weight-bold display-3 text-xs-center">
            Основные параметры
          </div>
        </span>
      </router-link>
    </template>

    <v-container fluid grid-list-xl py-0>
      <v-layout v-if="isLoaded">
        <v-flex
          v-if="!['sm', 'xs'].includes($vuetify.breakpoint.name)"
          :class="{ 'layout align-center justify-center ma-0': screenLoading }"
          xl3
          lg4
          md5
        >
          <v-tabs
            v-if="!screenLoading"
            v-model="tabPreview"
            slider-color="transparent"
            class="tabPreview mb-4"
            next-icon="icon icon-angle-right d-flex align-center"
            prev-icon="icon icon-angle-left d-flex align-center"
            centered
          >
            <v-tab class="text-none">Вход</v-tab>
            <v-tab class="text-none">Авторизация</v-tab>
          </v-tabs>

          <v-tabs-items v-if="!screenLoading" v-model="tabPreview">
            <v-tab-item>
              <theme-preview
                @openDialog="$emit('openDialog', $event)"
                :themeId="item.id"
                type="sm"
                page="login"
              ></theme-preview>
            </v-tab-item>
            <v-tab-item>
              <theme-preview
                @openDialog="$emit('openDialog', $event)"
                :themeId="item.id"
                type="sm"
                page="signin"
              ></theme-preview>
            </v-tab-item>
            <v-tab-item>
              <theme-preview
                @openDialog="$emit('openDialog', $event)"
                :themeId="item.id"
                type="sm"
                page="advertising"
              ></theme-preview>
            </v-tab-item>
          </v-tabs-items>

          <v-progress-circular
            v-if="screenLoading"
            :size="50"
            :width="2"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
        <v-flex
          xl9
          lg8
          md7
          class="d-flex justify-center"
          :class="{
            'content-bg--1': !['xs', 'sm'].includes($vuetify.breakpoint.name)
          }"
        >
          <div class="flex xl10 py-md-5">
            <v-tabs
              v-if="!isMobile"
              v-model="tabSection"
              :active-class="
                `
                  ${
                    $store.getters.themeDark ? 'primary--text' : 'text--primary'
                  }
                  v-tabs__item--active
                `
              "
              slider-color="transparent"
              class="pb-3 mb-5 v-tabs--border"
            >
              <v-tab
                class="display-1 font-weight-bold text-none text--secondary pr-4"
              >
                Основные настройки
              </v-tab>
              <v-tab
                class="display-1 font-weight-bold text-none text--secondary"
              >
                Цвета
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tabSection">
              <v-tab-item :transition="false" :reverse-transition="false">
                <theme-main-settings
                  @save="save"
                  @addHotspot="addHotspot"
                  @delHotspot="delHotspot"
                  :params="item"
                ></theme-main-settings>
              </v-tab-item>
              <v-tab-item :transition="false" :reverse-transition="false">
                <theme-color-settings
                  @save="save"
                  :params="item"
                ></theme-color-settings>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconArrow from "../components/icon/IconArrow.vue";
import ThemeMainSettings from "../components/theme/ThemeMainSettings.vue";
import ThemeColorSettings from "../components/theme/ThemeColorSettings.vue";
import ThemePreview from "../components/theme/ThemePreview.vue";
import merge from "lodash.merge";

export default {
  name: "ThemeSettingsView",

  components: {
    ThemePreview,
    ThemeColorSettings,
    ThemeMainSettings,
    IconArrow,
    BaseLayout
  },

  data: () => ({
    // активные элементы для tabs
    // основные настройки или цвета
    tabSection: 0,
    // стр. превьюшки
    tabPreview: 0,
    // loader при загрузке скриншота
    screenLoading: false
  }),

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad");
    // загружаем список тем
    this.$store.dispatch("themeListLoad");
    // загружаем список рекламы
    this.$store.dispatch("advListLoad");
  },

  computed: {
    // id темы, если передана в роуте
    id: {
      get() {
        return parseInt(this.$route.params.id);
      },
      set(val) {
        return val;
      }
    },
    // проверка загрузки тем
    isLoaded() {
      if (!this.id) {
        return true;
      } else if (this.$store.getters.themeIsLoaded) {
        return true;
      }
      return false;
    },
    // получения объекта темы
    item() {
      let item = { ...this.$store.getters.themeDefaultParams };
      if (this.id && this.isLoaded) {
        // отдельное сохранение цветов
        let colorParams = merge(
          item.color.colors,
          this.$store.getters.getTheme(this.id).color.colors
        );
        item = { ...item, ...this.$store.getters.getTheme(this.id) };
        item.color.colors = colorParams;
      }
      return item;
    },
    // для мобильной версии
    isMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    }
  },

  methods: {
    /**
     * Сохранения изменений в теме
     */
    save(params) {
      const item = { ...this.item, ...params };

      if (this.id) {
        this.edit(item).then(() => {
          this.setScreenshote(["login", "signin"]);
          // скрин рекламы если изменилась
          if (item.advertising_id) {
            this.setScreenshote(["advertising"]);
          }
        });
      } else {
        this.create(item).then(() => {
          // обновляем скриншоты
          this.setScreenshote(["login", "signin"]);
          if (item.advertising_id) {
            this.setScreenshote(["advertising"]);
          }
        });
      }
    },

    /**
     * Добавление темы
     */
    create(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("createTheme", params)
          .then(data => {
            this.id = data.id;
            this.$router.push({
              name: "themeSettings",
              params: { id: data.id }
            });

            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Тема успешно добавлена"
            });

            resolve();
          })
          .catch(reject);
      });
    },

    /**
     * Редактирование темы
     */
    edit(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("editTheme", params)
          .then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Тема успешно изменена"
            });

            resolve();
          })
          .catch(reject);
      });
    },

    /**
     * Добавляет хотспот к теме
     * id - id хотспота
     */
    addHotspot(hotspot_id) {
      // если тема еще не создана, создаем
      if (!this.id) {
        this.create(this.item).then(() => this.createHotspotTheme(hotspot_id));
      } else {
        this.createHotspotTheme(hotspot_id);
      }
    },

    createHotspotTheme(hotspot_id) {
      // предварительно удаляем тему у указанного хотспота
      this.$store
        .dispatch("deleteHotspotTheme", { hotspot_id: hotspot_id })
        .then(() => {
          this.$store
            .dispatch("createHotspotTheme", {
              hotspot_id: hotspot_id,
              theme_id: this.id
            })
            .then(() => {
              // открываем сообщение
              this.$store.dispatch("popupInfoOpen", {
                text: "Хотспот успешно прикреплен к теме"
              });
            });
        });
    },

    /**
     * Удаляет хотспот из темы
     * id - id хотспота
     */
    delHotspot(hotspot_id) {
      // todo удаляем файлы с сервера

      // удаляем тему
      this.$store
        .dispatch("deleteHotspotTheme", {
          hotspot_id: hotspot_id,
          theme_id: this.item.id
        })
        .then(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: "Хотспот успешно откреплен от темы"
          });
        });
    },

    /**
     * Получение скриншотов для preview темы
     */
    setScreenshote(pages) {
      const item = { ...this.item };
      this.screenLoading = true;

      // получает скриншоты для ПК и мобильной версии и сохраняет в тему
      Promise.all(
        ["xs", "xl"].map(size => {
          return new Promise((resolve, reject) => {
            this.$store
              .dispatch("setWifiAuthScreenshotes", {
                pages: pages,
                size: size,
                theme_id: item.id,
                advertising_id: item.advertising_id
              })
              .then(resolve)
              .catch(reject);
          });
        })
      )
        .then(values => {
          let items = {};
          values.forEach(value => {
            items = { ...items, ...value };
          });
          item.params.preview = { ...item.params.preview, ...items };

          this.$store.dispatch("editTheme", item).then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Скриншоты обновлены"
            });
            this.screenLoading = false;
          });
        })
        .catch(error => {
          console.error(error);
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: "Ошибка при обновлении скриншотов",
            type: "error"
          });
          this.screenLoading = false;
        });
    }
  }
};
</script>
